import { gql } from "@apollo/client";
import { RHTVChannelFragment } from "@/fragments/RockHallTv";

export const Channels = gql`
  ${RHTVChannelFragment}
  query RHTVChannels($language: String!) {
    rhtvChannels(first: 50, where: {language: $language}) {
      nodes {
        ...RhtvChannel
      }
    }
  }
`